const LangTermNConditionPopup = {
	"TnC.Button._Accept": ["Accept", "Đồng Ý"],
	"TnC.Button._Cancel": ["Cancel", "Hủy"],
	"TnC.Content": [
		`<p>
    <strong>TERMS OF USE FOR STARBUCKS REWARDS</strong>
    <strong><sup>TM</sup> </strong>
    <strong>PROGRAM&nbsp;</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>Updated: 02/07/2021</span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    PLEASE READ THESE TERMS OF USE CAREFULLY. BY ACCESSING OR PARTICIPATING IN THE STARBUCKS REWARDS™ PROGRAM OR USING THE STARBUCKS CARDS, YOU AGREE TO BE BOUND BY THESE TERMS OF USE AND ALL TERMS INCORPORATED BY REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS OF USE, DO NOT PARTICIPATE IN THE STARBUCKS REWARDS™ PROGRAM AND USE THE STARBUCKS CARDS.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    These Terms of Use apply to your access to, and use of, all or part of any website or mobile application, and participation in, the Starbucks Rewards™ Program which is operated by Viet Idea Food & Beverages Company Limited (“Starbucks”), a licensee of Starbucks Corporation in Vietnam. These Terms of Use do not alter in any way the terms or conditions of any other agreement you may have with Starbucks for other products and services. Starbucks reserves the right to change, modify and/or eliminate Starbucks Rewards™ Program and/or all or any portion of these Terms of Use or any policy, FAQs, or guideline pertaining to Starbucks Rewards™ Program at any time and in its sole discretion. Any changes or modifications will be effective immediately upon posting and notifying the revisions to
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        
        or mobile application “Starbucks Việt Nam” (“
    </span>
    <strong>Mobile Application</strong>
    <span style={{ fontWeight: 400 }}>
        ”). Your participation in Starbucks Rewards™ Program or use of the Starbucks Cards confirms your acceptance of these Terms of Use and any such changes or modifications; therefore, you should review these Terms of Use and applicable policies and FAQs frequently to understand the terms and conditions that apply to Starbucks Rewards™ Program and the Starbucks Cards. If you do not agree to these Terms of Use, you must stop participating in Starbucks Rewards™ Program and using the Starbucks Cards.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The Starbucks Rewards™ Program is intended for personal use only. Commercial use is prohibited. This program is not targeted towards, nor intended for use by, anyone under the age of 18.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Please read the&nbsp;Privacy Statement&nbsp;available at
    </span>
    <a href="http://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement">
        <span style={{ fontWeight: 400 }}>
            http://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
    carefully to understand how Starbucks collects, uses and discloses information about customers and how to update or change your personal information and how we communicate with you.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Starbucks Rewards™ Program is one way in which Starbucks endeavors to reward and thank loyal customers for patronizing our business, and purchasing Starbucks products. Members of Starbucks Rewards™ Program are able to earn and accumulate “Stars” that can be redeemed for Starbucks Rewards™ Program’s benefits, also known as “Rewards”, at Starbucks stores in Vietnam.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>
    <strong>Starbucks Card</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The Starbucks Card refers to a physical Starbucks branded plastic card or a Starbucks branded visual card (or E-Card) that is a
    </span>
    <span style={{ fontWeight: 400 }}>reusable gift card </span>
    <span style={{ fontWeight: 400 }}>
    that customers can load money onto and only use to make purchases at Starbucks stores. A Starbucks Card shall be identified by its own card number, security code (CSC) and barcode. The Starbucks Card is valid only in Vietnam (all Starbucks stores in Vietnam), and must be activated at the minimum value of VND100,000 per card for the first use. If you want to purchase Starbucks Cards as a gift, they just need to be activated. Once you activate a Starbucks Card, it can be used to make purchases just as you would use cash however the Starbucks Card is non-refundable as well as not exchangeable for cash or credit balance. Normally, you can check your Starbucks Card balance by asking the barista at the any Starbucks stores, and at
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        
        or the Mobile Application if you have registered to join
        the Starbucks Reward
    </span>
    <span style={{ fontWeight: 400 }}>TM</span>
    <span style={{ fontWeight: 400 }}>
        
        program. When the balance gets low, the Starbucks Card can be reloaded with for further purchase. For reloading, Starbucks Card can be reloaded in denominations of Vietnamese Dong for any amount between VND50,000 and VND5,000,000, provided that VND5,000,000 is the maximum amount a card can hold at any time. You are required to activate/reload the Starbucks Card by cash at a Starbucks store or using online payment function (via credit card/debits card/domestical ATM card) which is provided by our payment service providers, but you can’t use the Starbucks Card to activate/reload another Starbucks Card.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    A non-registered Starbucks Card has a duration of three (03) years as from the last financial transaction by using such non-registered Starbucks Card. Meanwhile, a registered Starbucks Card shall expire on the end date of a three (03) year-period as from the last financial transaction by using such registered Starbucks Card or on the termination date of the Starbucks Rewards™ Program as notified to the competent authority and announced at the Starbucks stores in Vietnam, subject to the sooner date. Within the scope of these Terms, the “financial transaction” shall be one of the following actions:&nbsp;
    </span>
</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>Activation</span>
    </li>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>Reload</span>
    </li>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Redemption Rewards for a registered Starbucks Card
        </span>
    </li>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Purchasing transaction
        </span>
    </li>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Fund Transfer (as defined herein below) between the
            registered Starbucks Cards within the same account.
        </span>
    </li>
</ul>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Upon the expiration of any Starbucks Card, the Starbucks
        Card balance shall become revenue of Starbucks without any
        Starbucks’ responsibility for the Starbucks Card holder.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <strong>Joining Starbucks Rewards™ Program</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        You can enroll in Starbucks Rewards™ Program and begin
        accumulating Stars by visiting
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        
        or installing applicable Mobile Application and following
        prompts to create a Starbucks Rewards™ account and
        register at least one (1) activated Starbucks Card to such
        account. Upon signing up an account, you will receive a
        verification email to your email address that is used for
        signing up and activating your account (Please contact us
        if you do not receive the verification email within 24
        hours).
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The registration process may require that you provide the following information: password, email address (required in order to receive all eligible Rewards), physical address, telephone number, the activated Starbucks Card number, and card security code (CSC), birthday, name and your preference on receiving the program’s news and promotions, preferences.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The Starbucks Card can be registered to your account at any given time. You can register / add maximum twenty (20) activated Starbucks Cards in such account. The Balance of a registered Starbucks Card (a transferred Starbucks Card) can be fully transferred to another registered Starbucks Card balance within one account (Fund Transfer), but the partial transfer is not permitted. The transferred Starbucks Card becomes empty yet remains active for further reloading and use. The invalid Starbucks Card is defined as no Stars earned. The transfer of Starbucks Card balance can be only performed personally by you via our website or on Mobile Application (Fund Transfer).
    </span>
</p>
<p>&nbsp;</p>
<p>
    <strong>Earning Stars&nbsp;</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Only transaction is paid by using Starbucks Card can earn
        Stars if that Starbucks Card has been
    </span>
    <span style={{ fontWeight: 400 }}>registered or added </span>
    <span style={{ fontWeight: 400 }}>
        into your Starbucks Rewards™ account.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The benefits that are available to you through Starbucks Rewards™ Program are based on the number of “Stars” that you earn. You can earn Stars by making purchases at any Starbucks store and presenting your relevant registered Starbucks Card or barcode on Mobile Application to the barista upon payment.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <strong>
        Please note that spending will only be calculated and
        Stars accumulated after the activated Starbucks Card is
        registered to your Starbucks Rewards
    </strong>
    <span style={{ fontWeight: 400 }}>™</span>
    <strong>
        
        account and you must present your relevant registered
        Starbucks Card or barcode on Mobile Application for
        scanning at the time of payment.&nbsp;
    </strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        No “Star” will be rewarded for purchases with a registered
        Starbucks Card in any Starbucks store outside Vietnam or
        for purchases of Starbucks gift card.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    You will earn Stars based on the value of your purchase at the rate of one (1) Star for each forty thousand Vietnamese Dong (40,000₫) you spend using any one of your registered Starbucks Card, which has the relevant for the payment. At Starbucks’ sole discretion, Stars may be earned and awarded in fractional amounts depending on the value of your purchase paid fully by using registered Starbucks Card(s) only.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Generally speaking, Stars for qualifying purchases from Starbucks stores are automatically added to your account at the earliest after the transaction is completed or within approximately forty-eight (48) hours. From time to time, we, or others acting with our permission, may offer you special promotions that offer you “Promotional Stars.” Promotional Stars, such as “bonus” Stars, will be awarded as described in the applicable promotional offer and will be subject to any additional terms set forth in the promotional offer.
    </span>
</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>
    <strong>Starbucks Rewards™ Program Benefit Levels</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Currently, there are two (2) levels of benefits within Starbucks Rewards™ Program that are determined by a number of Stars that you accumulate in your account each consecutive twelve (12)-month period. By opening an account and registering an activated Starbucks Card, you will be automatically enrolled in Starbucks Rewards™ Program at the Green Level. If you earn one hundred (100) new Stars within the twelve (12)-month period following your enrollment date, you will qualify for the Gold Level.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Once you reach a specific level within Starbucks Rewards™
        Program, you will receive the benefits that are applicable
        to that level at that time.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        To maintain all benefits of the Green Level, you only need
        to register at least one (1) of your activated Starbucks
        Card to your account.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        To maintain all benefits of the Gold Level, you must earn
        at least one hundred (100) new Stars during each
        consecutive twelve (12)-month period following the date
        that you reached the Gold Level. At the anniversary date
        of the Gold level, your star count will be reset. For your
        information, the reset at Gold Level means the Stars
        balance after dividend by 25, and not more than 25 Stars.
    </span>
    <strong>
        If you do not earn one hundred (100) new Stars in each
        twelve (12)-month period, you will be placed at the Green
        Level of Starbucks Rewards™ Program and your Star balance
        will automatically reset to zero (0).
    </strong>
</p>
<p>&nbsp;</p>
<p>
    <strong>
        Please note that Stars accumulated for each level of the
        Starbucks Rewards™ Program will only be valid for twelve
        (12)-month from the date when you reach the particular
        level. However, any Rewards you have accumulated but which
        have not been used and have not expired will remain
        available in your account and you can redeem such Rewards
        in accordance with the prescribed conditions herein.&nbsp;
    </strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        You can view or track your Star balance and available
        Rewards on
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        
        or the Mobile Application. Starbucks reserves the right to
        change a number of benefit levels and to change the
        benefits and Rewards associated with each level in its
        sole discretion at any time.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <strong>Green Level</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        By registering your activated Starbucks Card, you are
        automatically entered into the “Green Level” of Starbucks
        Rewards™ Program, or failure to earn one hundred (100)
        Stars in a twelve (12)-month period for upgrading the Gold
        Level, you will remain at the “Green Level” and your Star
        balance will be reset to zero (0). Rewards may include:
    </span>
</p>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Buy-One-Get-One Reward (“BOGO Reward”). You will
            receive one (1) Buy-One-Get-One on tall or above-sized
            handcrafted beverages upon earning your first five (5)
            Stars, as described below:
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Your BOGO Reward will be automatically added to your
            account within approximately forty-eight (48) hours
            upon earning your first five (5) Stars in one
            Starbucks Rewards™ account. The offer for the BOGO
            Reward expires after one (1) month from the date that
            such Reward is loaded onto your account. You must
            present your registered physical Starbucks Card or
            relevant barcode on Mobile Application to the barista
            at a Starbucks store in order to redeem your Reward
            and receive your BOGO item. The BOGO Reward may be
            redeemed at Starbucks stores only and is not available
            to ready-to-drink bottled beverages.
        </span>
    </li>
</ul>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Birthday Reward. You will receive one (1)
            complimentary slice of cake in the month of your
            birthday as described below:
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            The complimentary birthday Reward will be
            automatically added to your account on the first day
            of your birthday month. The offer for the
            complimentary birthday Reward expires the day after
            your birthday month. You must present your registered
            Starbucks Card or relevant barcode on Mobile
            Application to the barista at a Starbucks store in
            order to redeem your Reward and receive your
            complimentary birthday item. You will receive only one
            (1) birthday Reward regardless of the number of
            registered Starbucks Cards you may have. The
            complimentary birthday Reward may be redeemed at
            Starbucks stores only.
        </span>
    </li>
</ul>
<p>
    <strong>Gold Level</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Upon earning one hundred (100) Stars in a twelve
        (12)-month period, you will be placed at the “Gold Level”
        and your Star balance will be reset. For your information,
        the reset at Gold Level means the Stars balance after
        dividend by 25, and not more than 25 Stars. During each
        twelve (12)-month period when you reach and/or maintain
        the Gold Level, the benefits of the Gold Level may
        include:
    </span>
</p>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Green Level Rewards. You will still be able to redeem
            any Green Level Rewards which have not been redeemed
            and have not expired before you reached the Gold
            Level, however you must redeem such unused Rewards
            within their prescribed validity period.
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Birthday Reward. You will receive one (1)
            complimentary slice of cake in the month of your
            birthday as described below:
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            The complimentary birthday Reward will be
            automatically added to your account on the first day
            of your birthday month. The offer for the
            complimentary birthday Reward expires the day after
            your birthday month. You must present your relevant
            registered Starbucks Card or barcode on Mobile
            Application to the barista at a Starbucks store in
            order to redeem your Reward and receive your
            complimentary birthday item. You will receive only one
            (1) birthday Reward regardless of the number of
            registered Starbucks Cards you may have. The
            complimentary birthday Reward may be redeemed at
            Starbucks stores only.
        </span>
    </li>
</ul>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Buy-One-Get-One Reward (“BOGO Reward”). You will
            receive one (1) BOGO Reward on any tall or above-sized
            handcrafted beverage as described below:
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Your BOGO Reward will be automatically loaded onto
            your account within approximately forty-eight (48)
            hours upon reaching the Gold Level. The offer for the
            BOGO Reward expires after one (1) month from the date
            that such Reward is loaded onto your account. You must
            present your relevant registered Starbucks Card or
            barcode on Mobile Application to the barista at a
            Starbucks store in order to redeem your Reward and
            receive your BOGO item. The BOGO Reward may be
            redeemed at Starbucks stores only and is not available
            to ready-to-drink bottled beverages.
        </span>
    </li>
</ul>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Free Drink Reward. You will receive one (1) free tall
            size handcrafted drink of your choice for every
            twenty-five (25) additional Stars that you earn above
            the one hundred (100) Stars needed to reach the Gold
            Level, as described below:
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<ul>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Your Free Drink Reward will be automatically loaded
            onto your account within approximately forty-eight
            (48) hours upon you earning every twenty-five (25)
            additional Stars. The Free Drink Reward expires after
            one (1) month from the date that the Free Drink Reward
            is loaded onto your account. You must present your
            relevant registered Starbucks Card or barcode on
            Mobile Application to the barista at a Starbucks store
            in order to redeem your Reward and receive your Free
            Drink item. You will receive only one (1) Free Drink
            Reward for every twenty-five (25) additional Stars
            that you accumulate. The Free Drink Reward may be
            redeemed at Starbucks stores only and is not available
            to ready-to-drink bottled beverages.
        </span>
    </li>
</ul>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
            Special offers and/or invitations. You may, at the
            sole discretion of Starbucks, receive additional
            special offer(s) and/or invitation(s) to participate
            in event(s) held by or for Starbucks by email or
            physical mail.
        </span>
        <strong>
            You must opt-in to receive promotional and marketing
            offers from Starbucks and may be required to provide a
            valid email, telephone and physical address in order
            to receive your special offers and invitations
        </strong>
        <span style={{ fontWeight: 400 }}>
            . Special offers and invitations may be customized
            based on purchase behaviors and preferences. Special
            offers may include periodic discounts on foods, drinks
            and merchandise. Special offers may have certain
            restrictions including expiration dates and short
            time-limited redemption periods. Special offers are
            personal to you and cannot be shared, copied or
            transferred. You may be required to present your
            relevant registered Starbucks Card or barcode on
            Mobile Application in order to redeem special offers.
            Read each offer carefully for specific details,
            expiration dates, limitations and restrictions when
            such offer is loaded onto your account.
        </span>
    </li>
</ol>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        You are responsible for updating your Starbucks Rewards™
    </span>
    <span style={{ fontWeight: 400 }}>
        account and ensuring all information you provide in your
        account is accurate and up to date at all times, including
        your email and mailing addresses at
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        . If any information you provide is not accurate or up to
        date, you may not receive special offer(s) and/or
        invitation(s). You can view and track your available
        offer(s) and/or invitation(s) on
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        
        or on the Mobile Application.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <strong>Mobile Order & Pay</strong>
</p>
<p>
    <span style={{ fontWeight: 400 }}>
    This Mobile Order & Pay</span>
    <strong>(“MO&P”)</strong>
    <span style={{ fontWeight: 400 }}>
    feature allows you to place an order and pay ahead before reaching the selected Starbucks store, and ask a barista for your freshly made order at the pickup area at estimated pick-up time without waiting in line nor additional service fee for this feature. This feature is only integrated into the Mobile Application and applied for member(s) of Starbucks Rewards™ Program. You are requested to turn on your location services and ensure the most recent update for the Mobile Application for discovering this new feature.
    </span>
</p>
<p>&nbsp;</p>
<span style={{ fontWeight: 400 }}>
The MO&P is currently available via the Mobile Application for your use by the following simple steps:
</span>
<p>&nbsp;</p>
<ol>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Open the latest version of the Mobile Application and log into your account
        </strong>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Click on the "Order" option from the menu:
        </strong>
        <span style={{ fontWeight: 400 }}>
        Your location services on your devices are requested to turn on for starting to use this feature
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Select the food and beverage items to order:
        </strong>
        <span style={{ fontWeight: 400 }}>
        Just as in our stores, food and beverages are customizable, including numerous options to modify size, number of espresso shots, dairy selections and more.
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Select the store for pick up:
        </strong>
        <span style={{ fontWeight: 400 }}>
        Approximate pick-up time will be viewable on the your device prior to selecting Starbucks store location. Menu items will also be updated based on availability after the Starbucks store is selected. You should review to ensure your selections / orders are available at the selected Starbucks store before hitting “checkout”.
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Confirm by clicking "Order":
        </strong>
        <span style={{ fontWeight: 400 }}>
        Details information of your orders, estimated pick-up time, pick-up store and total amount for your payment will be displayed for your review and confirmation.
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Proceed the payment:
        </strong>
        <span style={{ fontWeight: 400 }}>
        Payment is made from your default registered Starbucks Card
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Finish your order:
        </strong>
        <span style={{ fontWeight: 400 }}>
        A pop-up notification with eReciept for your order and a count down of estimated pick-up time will be shown. You can also check such information and at Transaction history.
        </span>
    </li>
    <p>&nbsp;</p>
    <li style={{ fontWeight: 400 }}>
        <strong>
        Proceed to the selected Starbucks store to pick up your food and beverages:
        </strong>
        <span style={{ fontWeight: 400 }}>
        Orders are immediately sent to the selected Starbucks store where baristas will begin preparing the items. When baristas have finished your order, you will receive a push notification provided via the Mobile Application for picking up within the estimated pick-up time and enjoy your food / drink.
        </span>
    </li>
</>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Initially, the Mobile Application will default to your latest order and the closest available Starbucks store within 50 kilometers to your current location, as well as display the current menu availability and estimated pick-up time for your order from that store. You can change stores by tapping the map or using the "Pickup at" button in the app. Once your order is submitted, you cannot change the pickup store. You can only place an order once the selected Starbucks store is open and up to 30 minutes before such Starbucks store is closed.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Almost all of your favorite Starbucks beverages and food are available through the MO&P except for alcoholic beverage, ready to drink,  merchandise and whole beans. The menu for your selection will list all available offerings at the same price at the selected Starbucks store. With a few taps on your device, you can customize your favorite beverages and choose to have food items served warm, just as you can with in-store orders.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    When you place your order, you will be given an estimated pick-up time without any option for you to change or specify such time. Times will vary depending on a variety of factors including the Starbucks store availability, a number of items ordered and time of day. You can go to the selected Starbucks store within the approximate pick-up time.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    The payment for your order via the MO&P must be completed via a registered Starbucks Card through the Mobile Application. Your prepaid amount on such registered Starbucks Card will be deducted for such order transaction by our system. Starbucks also has its own security standards for this deduction transactions to ensure the security and safety information. In the event of an unexpected transaction occurred, please contact our Customers Care Center so that we can assist promptly..
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    After placing an order through the MO&P, it is immediately sent to the selected Starbucks store and our baristas will begin preparing the order. You cannot change the selected Starbucks store, modify or cancel the order, return the order items, request for refund in any circumstances, or place any other order at a time.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    Please ensure notifications are allowed under settings in the Mobile Application and your device in order to receive push notification when your order is ready for pick up at selected Starbucks store within the estimated pick-up time. You acknowledge that Starbucks cannot maintain the quality of the ordered items as you wish in the event that you pick up later than the estimated pick-up time despite of receiving the push notification and agree not to hold Starbucks harmless from any liability in this event. However, to the possible extent, we always try to bring the best quality products to you.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    You can also earn Stars for the purchases made through the MO&P
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
    You can contact our Starbucks Rewards™ Customer Care Center according to information at the below if you have any problem during using the MO&P.
</p>
<p>&nbsp;</p>
<p>
    <strong>Miscellaneous</strong>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        There is no membership fees associated with Starbucks
        Rewards™ Program, but required an activated Starbucks Card
        with minimum value of VND100,000 to register a Starbucks
        Rewards™ account. Stars accumulated under the program have
        no cash value.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Starbucks may introduce promotion programs relating to
        Starbucks Rewards™ Program whereby these Terms of Use may
        be varied as applicable to such programs.
    </span>
</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        The Starbucks Rewards™ Program shall be performed in the
        duration as notified to the competent authority and
        announced at the Starbucks stores in Vietnam. Accordingly,
        your Starbucks Rewards™ account and all your registered
        Starbucks Cards shall expire on termination date of the
        Starbucks Rewards™ Program, so that all accumulated Stars
        in your account are void on that termination date without
        any Starbucks’ responsibility to you. Under this
        circumstance, you will be notified to receive/redeem the
        balance of all your registered Starbucks Cards within the
        specified period which will be notified specifically to
        you.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Starbucks may, at its sole discretion, run the Starbucks
        Rewards™ Program for further period(s) subject to the
        notification to the competent authority, and in such case,
        Starbucks may, at its sole discretion, but does not have
        obligation, extend the duration of your Starbucks Rewards™
        account and registered Starbucks Card, subject to the
        provisions on duration of Starbucks Card as provided
        herein above in the Section with heading “Starbucks Card”
        and in this paragraph.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Unless otherwise required by applicable law, Starbucks
        will not accept or issue any exchanges or refunds for
        goods or services purchased at its Starbucks stores. In
        case of any refunds, Starbucks reserves the right to
        deduct, at its sole discretion, benefits, Stars earned,
        including Promotional Stars, if any, in respect of your
        purchase of the refunded goods or services.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        If your Starbucks Card is lost, stolen, or destroyed, you
        may lose the Starbucks Card balance. However, in case of
        member’s Starbucks Rewards™ Program, you may protect the
        Star balance on your Starbucks Rewards™ account and the
        Balance of such Starbucks Card if lost, stolen or
        destroyed by notifying it at
    </span>
    <a href="https://card.starbucks.vn">
        <span style={{ fontWeight: 400 }}>
            https://card.starbucks.vn
        </span>
    </a>
    <span style={{ fontWeight: 400 }}>
        or Mobile Application or calling to our Starbucks Rewards™
        Customer Care Center at (028) 7306 7676, and confirming
        your instruction. In case of having only one registered
        Starbucks Cards, a request for a replacement Card can be
        sent to us, accordingly, all Balance of the
        lost/stolen/destroyed Starbucks Card can be transferred to
        the alternative Card and you can continue to redeem the
        unused Rewards within their prescribed validity period by
        using such alternative Card, otherwise, the Balance of the
        lost/stolen/destroyed Starbucks Card can be transferred to
        the others of yours.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Your Stars, Rewards, registered Starbucks Card(s), and
        your account under Starbucks Rewards™ Program are personal
        to you and may not be sold, transferred or assigned to, or
        shared with family, friends or others, or used by you for
        any commercial purpose. You are required to use your email
        address&nbsp; for registration of your Starbucks Rewards™
        account that is personal to you, and each your email
        address can be used for register only one (1) Starbucks
        Rewards™ account.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Without notice to you, Starbucks also reserves the right
        to “unregister” your Starbucks&nbsp; Rewards™ account of
        which all registered Starbucks Cards have been expired or
        deactivated as case may be. In the event that your
        Starbucks Rewards™ account is unregistered or rendered
        inactive, then all accumulated Stars in your account are
        void.&nbsp;
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        Without notice to you, Starbucks reserves the right to
        suspend any of your registered Starbucks Card and/or
        terminate your Starbucks Rewards™ account and/or your
        participation into Starbucks Rewards™ Program if Starbucks
        determines in its sole discretion that you have violated
        any term of these Terms of Use and terms incorporated by
        reference, or one your email address is used for
        registration of more than one (1) Starbucks Rewards™
        account, or that the use of your Starbucks Rewards™
        account is unauthorized, deceptive, fraudulent or
        otherwise unlawful. Starbucks may, in its sole discretion,
        suspend, cancel or combine accounts that appear to be
        duplicative. In the event that your participation into
        Starbucks Rewards™ Program is terminated, then all
        accumulated Stars in your account are void, and all your
        registered Starbucks Cards balance shall become revenue of
        Starbucks without any Starbucks’ responsibility for the
        Starbucks Card holder.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        All claims or disputes arising out of or in relation to
        these Terms of Use or the Starbucks Rewards™ Program shall
        be resolved in accordance with applicable laws in Vietnam.
    </span>
</p>
<p>&nbsp;</p>
<p>
    <span style={{ fontWeight: 400 }}>
        If you have any inquiries related to Starbucks Rewards™
        Program, please contact Viet Idea Food &amp; Beverages
        Company Limited by postal mail at 76 Le Lai, District 1,
        HCMC or via our Starbucks Rewards™ Customer Care Center at
        (028)7306 7676.
    </span>
</p>`,
		`<div>
        <p><strong>ĐIỀU KHOẢN SỬ DỤNG ĐỐI VỚI CHƯƠNG TRÌNH STARBUCKS REWARDS</strong><sup>TM</sup></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Cập nhật ngày: 02/07/2021</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>VUI LÒNG ĐỌC KỸ NHỮNG ĐIỀU KHOẢN SỬ DỤNG NÀY. BẰNG CÁCH TRUY CẬP HOẶC THAM GIA VÀO CHƯƠNG TRÌNH STARBUCKS REWARDS™ HOẶC SỬ DỤNG THẺ STARBUCKS, BẠN ĐỒNG Ý BỊ RÀNG BUỘC BỞI NHỮNG ĐIỀU KHOẢN SỬ DỤNG NÀY VÀ TẤT CẢ CÁC ĐIỀU KHOẢN ĐƯỢC KẾT HỢP BẰNG VIỆC THAM CHIẾU. NẾU BẠN KHÔNG ĐỒNG Ý VỚI NHỮNG ĐIỀU KHOẢN SỬ DỤNG NÀY, VUI LÒNG KHÔNG THAM GIA VÀO CHƯƠNG TRÌNH STARBUCKS REWARDS™ VÀ SỬ DỤNG THẺ STARBUCKS.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Các Điều Khoản Sử Dụng này được áp dụng đối với việc bạn truy cập, và sử dụng một phần hoặc toàn bộ website hay ứng dụng di động, và tham gia vào, Chương trình Starbucks Rewards</span><span style={{fontWeight: 400}}>TM</span><span style={{fontWeight: 400}}> do Công ty TNHH Thực phẩm &amp; Nước giải khát Ý Tưởng Việt (“Starbucks”) - đơn vị được cấp phép tại Việt Nam của Starbucks Corporation - thực hiện. Các Điều Khoản Sử Dụng này không làm thay đổi theo bất cứ cách nào các điều khoản hoặc điều kiện của bất cứ thỏa thuận nào khác mà bạn có thể giao kết với Starbucks về các sản phẩm và dịch vụ khác. Starbucks có quyền thay đổi, chỉnh sửa và/hoặc loại bỏ Chương trình Starbucks Rewards™ và/hoặc tất cả hoặc bất cứ phần nào của các Điều Khoản Sử Dụng này hoặc bất cứ chính sách, Câu Hỏi Thường Gặp, hoặc hướng dẫn nào liên quan đến Chương trình Starbucks Rewards™ tại bất cứ thời điểm nào và theo quyền quyết định chỉ riêng của Starbucks. Bất cứ thay đổi hoặc sửa đổi nào sẽ có hiệu lực ngay khi đăng tải và thông báo về những nội dung chỉnh sửa tại </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a><span style={{fontWeight: 400}}>, hoặc ứng dụng di động “Starbucks Việt Nam” </span><strong>(“Ứng Dụng Di Động”)</strong><span style={{fontWeight: 400}}>. Sự tham gia của bạn vào Chương trình Starbucks Rewards™ hoặc việc sử dụng Thẻ Starbucks xác nhận sự chấp nhận của bạn về các Điều Khoản Sử Dụng này và bất cứ thay đổi hoặc sửa đổi nào như thế; do vậy, bạn phải thường xuyên xem các Điều Khoản Sử Dụng này và các chính sách áp dụng và Câu Hỏi Thường Gặp để hiểu các điều khoản và điều kiện áp dụng cho Chương trình Starbucks Rewards™ và Thẻ Starbucks . Nếu bạn không đồng ý các Điều Khoản Sử Dụng này, bạn phải chấm dứt việc tham gia vào Chương trình Starbucks Rewards™ và chấm dứt việc sử dụng Thẻ Starbucks.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Chương trình Starbucks Rewards™ là dành cho việc sử dụng cá nhân. Việc sử dụng cho mục đích thương mại là bị cấm. Chương trình này không nhằm tới, cũng không được dự liệu cho việc sử dụng bởi bất cứ người nào dưới 18 tuổi.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Xin vui lòng xem kỹ Chính Sách Bảo Mật Thông Tin có tại </span><a href="http://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement"><span style={{fontWeight: 400}}>http://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement</span></a><span style={{fontWeight: 400}}> để hiểu cách Starbucks thu thập, sử dụng, tiết lộ các thông tin về khách hàng và cách để cập nhật hoặc thay đổi thông tin cá nhân của bạn cũng như cách chúng tôi liên lạc với bạn.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Chương trình Starbucks Rewards™ là một cách thức thể hiện sự nỗ lực của Starbucks để tri ân và cảm ơn khách hàng trung thành ủng hộ hoạt động kinh doanh, và mua các sản phẩm Starbucks® của chúng tôi. Các thành viên của Chương trình Starbucks Rewards™ có thể nhận được và tích lũy “Điểm Ngôi Sao” mà có thể được sử dụng để hưởng các lợi ích của Chương trình Starbucks Rewards™, còn được biết đến như là “Ưu Đãi”, tại các cửa hàng Starbucks® tại Việt Nam.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><strong>Thẻ Starbucks</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Thẻ Starbucks là một thẻ nhựa vật lý mang thương hiệu Starbucks hoặc một thẻ ảo mang thương hiệu Starbucks (hoặc “Thẻ Điện Tử”) có thể tái sử dụng nhiều lần khi khách hàng nạp tiền vào thẻ và sử dụng để mua hàng tại các cửa hàng Starbucks. Thẻ Starbucks sẽ được nhận dạng bằng số thẻ, mã bảo mật (CSC) và mã mạch của nó. Thẻ Starbucks có giá trị sử dụng tại Việt Nam (tại tất cả cửa hàng Starbucks tại Việt Nam), và phải được kích hoạt với giá trị tối thiểu là 100.000 VNĐ ở lần sử dụng đầu tiên tại bất kỳ thời điểm nào. Nếu bạn muốn mua Thẻ Starbucks làm thẻ quà tặng, thẻ chỉ cần đã kích hoạt. Khi bạn kích hoạt Thẻ Starbucks, nó có thể được sử dụng để mua hàng như việc bạn sử dụng tiền mặt hoặc thẻ tín dụng nhưng theo cách dễ dàng và nhanh hơn, tuy nhiên số dư trong Thẻ Starbucks không được hoàn lại cũng như không thể chuyển đổi thành tiền mặt hoặc số dư trong thẻ tín dụng. Thông thường, bạn có thể kiểm tra số dư trong Thẻ Starbucks của bạn, hãy đề nghị nhân viên pha chế tại bất kỳ cửa hàng Starbucks nào để họ kiểm tra giúp bạn. Đối với các thẻ Starbucks đã được đăng ký tài khoản, bạn có thể kiểm tra số dư tại </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a><span style={{fontWeight: 400}}> hoặc thông qua Ứng Dụng Di Động nếu bạn đã đăng ký tham gia chương trình Starbucks Reward</span><span style={{fontWeight: 400}}>TM</span><span style={{fontWeight: 400}}>.&nbsp; Khi số dư còn lại không đủ để mua hàng, bạn có thể nạp thêm tiền vào Thẻ Starbucks để tiếp tục thực hiện việc mua hàng. Đối với việc nạp tiền, bạn có thể sử dụng Việt Nam Đồng nạp vào Thẻ Starbucks với giá trị nạp từ 50.000 đồng đến 5.000.000 đồng, trong đó 5.000.000 đồng là số tiền tối đa có trong một thẻ tại mọi thời điểm. Bạn phải kích hoạt/nạp tiền vào Thẻ Starbucks bằng tiền mặt tại cửa hàng Starbucks hoặc sử dụng chức năng thanh toán trực tuyến (thông qua thẻ tín dụng/thẻ ghi nợ/thẻ ATM nội địa) do nhà cung cấp dịch vụ thanh toán của chúng tôi cung cấp, nhưng bạn không thể sử dụng Thẻ Starbucks để kích hoạt / nạp tiền cho một Thẻ Starbucks khác.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Thẻ Starbucks chưa đăng ký có thời hạn sử dụng trong vòng ba (03) năm kể từ thời điểm giao dịch tài chính cuối cùng được thực hiện bằng cách sử dụng Thẻ Starbucks đó. Trong khi đó, Thẻ Starbucks đã đăng ký sẽ hết hạn vào ngày cuối cùng của thời hạn ba (03) năm kể từ thời điểm giao dịch tài chính cuối cùng được thực hiện bằng cách sử dụng Thẻ Starbucks đó hoặc vào ngày chấm dứt Chương trình Starbucks Rewards™ như đã thông báo cho cơ quan có thẩm quyền và công bố tại các cửa hàng Starbucks ở Việt Nam, tùy thuộc vào thời điểm nào sớm hơn. Trong phạm vi các Điều Khoản Sử Dụng này, "Giao dịch tài chính" được hiểu là một trong các hành động sau đây:</span></p>
        <ul>
          <li><span style={{fontWeight: 400}}>Kích hoạt thẻ</span></li>
          <li><span style={{fontWeight: 400}}>Nạp tiền vào thẻ</span></li>
          <li><span style={{fontWeight: 400}}>Sử dụng Ưu Đãi đối với Thẻ Starbucks đã đăng ký</span></li>
          <li><span style={{fontWeight: 400}}>Giao dịch mua hàng</span></li>
          <li><span style={{fontWeight: 400}}>Chuyển tiền (như được định nghĩa dưới đây) giữa các Thẻ Starbucks đã đăng ký trong cùng một tài khoản.</span></li>
        </ul>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Khi Thẻ Starbucks hết hạn, số dư trong Thẻ Starbucks sẽ trở thành doanh thu của Starbucks mà Starbucks không phải chịu bất kỳ trách nhiệm tài chính nào đối với người sở hữu Thẻ Starbucks.</span></p>
        <p>&nbsp;</p>
        <p><strong>Tham gia vào Chương trình Starbucks Rewards™</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bạn có thể tham gia vào Chương trình Starbucks Rewards™ và bắt đầu tích lũy Điểm Ngôi Sao bằng cách truy cập vào </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a> <span style={{fontWeight: 400}}>hoặc cài đặt Ứng Dụng Di Động và làm theo hướng dẫn để tạo một tài khoản Starbucks Rewards</span><span style={{fontWeight: 400}}>TM</span><span style={{fontWeight: 400}}> và đăng ký vào tài khoản đó tối thiểu một (1) Thẻ Starbucks đã kích hoạt. Khi đăng ký một tài khoản, bạn sẽ nhận được một email xác minh gửi đến địa chỉ email được sử dụng để đăng ký và kích hoạt tài khoản của bạn (Vui lòng liên hệ với chúng tôi nếu bạn không nhận được email xác minh việc đăng ký trong vòng 24 giờ).</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Trong quá trình đăng ký, bạn có thể được yêu cầu cung cấp các thông tin sau: tên người dùng, mật khẩu, địa chỉ email (được yêu cầu để nhận tất cả Ưu Đãi đủ điều kiện), địa chỉ liên lạc, số điện thoại, số Thẻ Starbucks đã kích hoạt, mã bảo mật thẻ (CSC), ngày sinh, tên và sở thích của bạn về việc nhận các tin tức, khuyến mãi và ưu đãi của chương trình.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Thẻ Starbucks có thể được đăng ký vào tài khoản của bạn tại bất cứ thời điểm nào. Bạn có thể đăng ký / thêm tối đa hai mươi (20) Thẻ Starbucks đã kích hoạt vào tài khoản của bạn. Số dư thanh toán trong một Thẻ Starbucks (Thẻ Starbucks đã chuyển tiền) có thể được chuyển toàn bộ sang một Thẻ Starbucks đã đăng ký khác trong cùng một tài khoản (Chuyển Tiền) nhưng không được phép chuyển một phần số dư. Thẻ Starbucks đã chuyển tiền sẽ trở thành Thẻ không còn tiền nhưng Thẻ Starbucks này vẫn hoạt động để tiếp tục nạp tiền và sử dụng. Thẻ Starbucks không còn hiệu lực được xác định là không Thẻ tích lũy Điểm Ngôi Sao. Việc chuyển tiền giữa các Thẻ Starbucks chỉ được thực hiện bởi cá nhân bạn thông qua website của chúng tôi hoặc Ứng Dụng Di Động (Chuyển Tiền).</span></p>
        <p>&nbsp;</p>
        <p><strong>Tích Lũy Điểm Ngôi Sao&nbsp;</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bạn chỉ có thể tích lũy Điểm Ngôi Sao khi thực hiện giao dịch bằng cách sử dụng Thẻ Starbucks đã đăng ký hoặc đã được thêm vào tài khoản Starbucks Rewards™ của bạn.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Những ưu đãi bạn sẽ nhận được thông qua Chương trình Starbucks Rewards™ được dựa trên số lượng "Điểm Ngôi Sao" mà bạn tích lũy được. Bạn có thể tích lũy Điểm Ngôi Sao bằng cách mua hàng tại cửa hàng Starbucks và xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch trên Ứng Dụng Di Động của bạn cho nhân viên pha chế khi thực hiện thanh toán.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><strong>Xin lưu ý rằng khoản chi tiêu chỉ được quy đổi thành Điểm Ngôi Sao và tích lũy vào Thẻ Starbucks đã kích hoạt đã đăng ký vào tài khoản Starbucks Rewards</strong><strong>TM</strong><strong> và bạn phải xuất trình Thẻ Starbucks hoặc mã vạch tương ứng trên Ứng Dụng Di Động để quét tại thời điểm thanh toán</strong><span style={{fontWeight: 400}}>.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>“Điểm Ngôi Sao” sẽ không được tích lũy khi thanh toán mua hàng bằng Thẻ Starbucks đã đăng ký tại cửa hàng Starbucks nằm ngoài lãnh thổ Việt Nam hoặc khi mua thẻ quà tặng Starbucks.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Số Điểm Ngôi Sao bạn nhận được sẽ dựa trên giá trị mua hàng của bạn theo tỉ lệ một (1) Điểm Ngôi Sao cho mỗi bốn mươi ngàn đồng Việt Nam (40.000₫) bằng cách sử dụng một trong các Thẻ Starbucks đã đăng ký cho việc thanh toán giao dịch đó. Dựa theo quyết định của Starbucks, Điểm Ngôi Sao chỉ có thể được nhận và tích lũy ở mức phân số dựa trên giá trị mua hàng của bạn khi sử dụng Thẻ Starbucks đã đăng ký để thanh toán toàn bộ số tiền mua hàng của mỗi giao dịch.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Nói chung, Điểm Ngôi Sao đối với các khoản chi tiêu mua hàng tại các cửa hàng Starbucks đáp ứng điều kiện tích lũy sẽ được tự động thêm vào tài khoản của bạn tại thời điểm sớm nhất sau khi giao dịch được thực hiện thành công hoặc trong vòng 48 tiếng</span><strong>.</strong><span style={{fontWeight: 400}}>Tùy từng thời điểm, chúng tôi, hoặc các đơn vị khác dưới sự cho phép của chúng tôi, có thể cung cấp cho bạn những khuyến mại đặc biệt mà trao cho bạn "Điểm Ngôi Sao Khuyến Mại". Điểm Ngôi Sao Khuyến Mại, chẳng hạn như Điểm Ngôi Sao “thưởng", sẽ được tặng theo quy định trong đề nghị khuyến mại áp dụng và phải tuân thủ bất cứ điều khoản bổ sung nào được quy định trong đề nghị khuyến mại.</span></p>
        <p>&nbsp;</p>
        <p><strong>Quyền Lợi của Các Hạng Thẻ của Chương trình Starbucks Rewards™</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Hiện nay, có hai (2) hạng mức thẻ với lợi ích khác nhau trong Chương trình Starbucks Rewards™, được xác định theo số Điểm Ngôi Sao mà bạn tích lũy trong tài khoản của bạn mỗi giai đoạn mười hai (12) tháng. Bằng cách mở một tài khoản và đăng ký một Thẻ Starbucks đã kích hoạt, bạn sẽ tự động trở thành thành viên của Chương trình Starbucks Rewards™ ở Hạng Xanh. Nếu bạn tích lũy đủ một trăm (100) Điểm Ngôi Sao mới trong thời hạn mười hai (12) tháng kể từ ngày tham gia của bạn, bạn sẽ đủ điều kiện nâng cấp lên Hạng Vàng.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Khi bạn đạt được một hạng thẻ cụ thể của Chương trình Starbucks Rewards™, bạn sẽ nhận được những lợi ích đang áp dụng cho hạng thẻ đó tại thời điểm đó.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Để duy trì tất cả các lợi ích của Hạng Xanh, bạn chỉ cần đăng ký tối thiểu một (1) Thẻ Starbucks đã kích hoạt vào tài khoản của bạn.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Để duy trì tất cả các lợi ích của Hạng Vàng, bạn phải tích lũy ít nhất một trăm (100) Điểm Ngôi Sao mới trong khoảng thời gian mỗi mười hai (12) tháng liên tiếp sau ngày bạn đạt được Hạng Vàng. Tại ngày kỷ niệm của ngày đạt Hạng Vàng (12 tháng) kể từ ngày bạn được nâng cấp lên Hạng Vàng, Điểm Ngôi Sao của bạn sẽ được thiết lập lại. Để thông tin cho bạn, việc thiết lập lại tại Hạng Vàng có nghĩa là số dư Điểm Ngôi Sao sau khi chia cho 25 và không vượt quá 25 Điểm Ngôi Sao. </span><strong>Nếu bạn không tích lũy một trăm (100) Điểm Ngôi Sao mới trong thời gian mỗi mười hai (12) tháng, bạn sẽ bị hạ xuống Hạng Xanh của Chương trình Starbucks Rewards™ và số dư Điểm Ngôi Sao của bạn sẽ tự động trả lại về giá trị không (0).</strong></p>
        <p>&nbsp;</p>
        <p><strong>Xin lưu ý rằng Điểm Ngôi Sao được tích lũy cho mỗi hạng thẻ của Chương trình Starbucks Rewards™ chỉ có giá trị trong mười hai (12) tháng kể từ ngày bạn đạt hạng thành viên cụ thể. Tuy nhiên, bất cứ Ưu Đãi nào mà bạn đã tích lũy nhưng chưa sử dụng và chưa hết hạn vẫn tiếp tục áp dụng trong tài khoản của bạn và bạn có thể sử dụng Ưu Đãi đó theo các điều kiện được quy định tại đây.</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bạn có thể xem hoặc theo dõi số dư Điểm Ngôi Sao và Ưu Đãi hiện có của bạn tại </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a> <span style={{fontWeight: 400}}>hoặc Ứng Dụng Di Động.</span> <span style={{fontWeight: 400}}>Starbucks bảo lưu quyền thay đổi số lượng mức lợi ích và thay đổi những lợi ích và Ưu Đãi có liên quan đến mỗi mức lợi ích theo quyết định chỉ riêng của Starbucks tại bất cứ thời điểm nào.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><strong>Hạng Xanh</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bằng cách đăng ký Thẻ Starbucks đã kích hoạt của bạn, bạn tự động đạt được thành viên “Hạng Xanh" của Chương trình Starbucks Rewards™, hoặc đối với trường hợp bạn không tích lũy đủ một trăm (100) Điểm Ngôi Sao trong thời hạn mười hai (12) tháng cho việc nâng cấp lên thành viên Thẻ Vàng, bạn vẫn là thành viên Hạng Xanh nhưng Tổng Số Điểm Ngôi Sao sẽ trở về giá trị không (0). Ưu Đãi bao gồm:</span></p>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Mua-Một-Tặng-Một (“Ưu Đãi BOGO”). Bạn sẽ nhận được một (1) ưu đãi Mua-Một-Tặng-Một khi mua suất đồ uống pha chế cỡ vừa (tall) hoặc cỡ lớn hơn sau khi bạn đã tích lũy được năm (5) Điểm Ngôi Sao đầu tiên, như mô tả dưới đây:</span></li>
        </ol>
        <p>&nbsp;</p>
        <ul>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi BOGO của bạn sẽ được nạp tự động vào tài khoản của bạn trong vòng bốn mươi tám (48) giờ sau khi bạn tích lũy được năm (5) Điểm Ngôi Sao đầu tiên vào một tài khoản Starbucks Rewards. Ưu Đãi BOGO sẽ hết hạn sau một (1) tháng kể từ ngày Ưu Đãi đó được nạp vào tài khoản của bạn. Bạn phải xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trên Ứng Dụng Di Động của bạn cho nhân viên pha chế tại cửa hàng Starbucks để nhận Ưu Đãi của bạn và nhận được sản phẩm BOGO của bạn. Ưu Đãi BOGO chỉ có thể được nhận tại cửa hàng Starbucks, và không áp dụng cho đồ uống đóng chai sẵn.</span></li>
        </ul>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Sinh Nhật. Bạn sẽ nhận được một (1) phần bánh miễn phí trong tháng sinh nhật của bạn như mô tả dưới đây:</span></li>
        </ol>
        <p>&nbsp;</p>
        <ul>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Sinh Nhật miễn phí sẽ được nạp tự động vào tài khoản của bạn vào ngày đầu tiên của tháng sinh nhật của bạn. Ưu Đãi Sinh Nhật miễn phí hết hạn vào ngày cuối cùng trong tháng sinh nhật của bạn. Bạn phải xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trên Ứng Dụng Di Động cho nhân viên pha chế tại cửa hàng Starbucks để nhận Ưu Đãi của bạn và nhận được món quà tặng sinh nhật miễn phí của bạn. Bạn chỉ nhận được một (1) Ưu Đãi Sinh Nhật bất kể số lượng Thẻ Starbucks đã đăng ký mà bạn có thể sở hữu. Ưu Đãi Sinh Nhật miễn phí chỉ có thể được nhận tại cửa hàng Starbucks.</span></li>
        </ul>
        <p>&nbsp;</p>
        <p><strong>Hạng Vàng</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Khi bạn tích lũy được ít nhất một trăm (100) Điểm Ngôi Sao trong khoảng thời gian mười hai (12) tháng, bạn sẽ được nâng cấp lên hạng “Hạng Thẻ Vàng” và số dư Điểm Ngôi Sao của bạn sẽ được thiết lập lại. Để thông tin cho bạn, việc thiết lập lại tại Hạng Vàng có nghĩa là số dư Điểm Ngôi Sao sau khi chia cho 25 và không vượt quá 25 Điểm Ngôi Sao. Suốt mỗi khoảng thời gian mười hai (12) tháng từ ngày bạn được nâng cấp lên Hạng Vàng và/hoặc duy trì Hạng Vàng, những lợi ích đối với Hạng Thẻ Vàng bao gồm:</span></p>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Hạng Xanh. Bạn vẫn có thể nhận bất cứ Ưu Đãi Hạng Xanh nào chưa sử dụng và chưa hết hạn trước khi bạn được nâng cấp lên Hạng Vàng, tuy nhiên bạn phải sử dụng Ưu Đãi chưa được sử dụng đó trong thời hạn được quy định.</span></li>
        </ol>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Sinh Nhật. Bạn sẽ nhận được một (1) phần bánh miễn phí trong tháng sinh nhật của bạn như mô tả dưới đây:</span></li>
        </ol>
        <p>&nbsp;</p>
        <ul>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Sinh Nhật miễn phí sẽ được nạp tự động vào tài khoản của bạn vào ngày đầu tiên của tháng sinh nhật của bạn. Ưu Đãi Sinh Nhật miễn phí hết hạn vào ngày cuối cùng của tháng sinh nhật bạn. Bạn phải xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trong Ứng Dụng Di Động cho nhân viên pha chế tại cửa hàng Starbucks để nhận Ưu Đãi của bạn và nhận được món quà tặng sinh nhật miễn phí của bạn. Bạn chỉ nhận được một (1) Ưu Đãi Sinh Nhật bất kể số lượng Thẻ Starbucks đã đăng ký mà bạn có thể sở hữu. Ưu Đãi Sinh Nhật miễn phí chỉ có thể được nhận tại cửa hàng Starbucks.</span></li>
        </ul>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Mua-Một-Tặng-Một (“Ưu Đãi BOGO”). Bạn sẽ nhận được một (1) ưu đãi Mua-Một-Tặng-Một khi mua suất đồ uống pha chế cỡ vừa (tall) hoặc cỡ lớn hơn, như mô tả dưới đây:</span></li>
        </ol>
        <p>&nbsp;</p>
        <ul>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi BOGO của bạn sẽ được nạp tự động vào tài khoản của bạn trong vòng bốn mươi tám (48) giờ sau khi bạn đạt Hạng Vàng. Ưu Đãi BOGO sẽ hết hạn sau một (1) tháng kể từ ngày Ưu Đãi đó được nạp vào tài khoản của bạn. Bạn phải xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trên Ứng Dụng Di Động của bạn cho nhân viên pha chế tại cửa hàng Starbucks để nhận Ưu Đãi của bạn và nhận sản phẩm BOGO của bạn. Ưu Đãi BOGO chỉ có thể được nhận tại cửa hàng Starbucks, và không áp dụng cho đồ uống đóng chai sẵn.</span></li>
        </ul>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Đồ Uống Miễn Phí. Bạn sẽ nhận được một (1) phần đồ uống miễn phí cỡ vừa (tall) theo sự lựa chọn của bạn cho mỗi hai mươi lăm (25) Điểm Ngôi Sao tăng thêm sau khi bạn tích lũy được trên một trăm (100) Điểm Ngôi Sao cần thiết để nâng cấp lên hạng Hạng Thẻ Vàng, như được mô tả dưới đây:</span></li>
        </ol>
        <p>&nbsp;</p>
        <ul>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Đồ Uống Miễn Phí của bạn sẽ được nạp tự động vào tài khoản của bạn trong vòng bốn mươi tám (48) giờ sau khi bạn tích lũy được mỗi hai mươi lăm (25) Điểm Ngôi Sao tăng thêm. Ưu Đãi Đồ Uống Miễn Phí hết hạn sau một (1) tháng kể từ ngày Ưu Đãi Đồ Uống Miễn Phí được nạp vào tài khoản của bạn. Bạn phải xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trên Ứng Dụng Di Động của bạn cho nhân viên pha chế tại cửa hàng Starbucks để nhận Ưu Đãi của bạn và nhận đồ uống miễn phí của bạn. Bạn sẽ chỉ nhận được một (1) phần Ưu Đãi Đồ Uống Miễn Phí cho mỗi hai mươi lăm (25) Điểm Ngôi Sao tăng thêm mà bạn tích lũy. Ưu Đãi Đồ Uống Miễn Phí chỉ có thể được nhận tại cửa hàng Starbucks, và không áp dụng cho đồ uống đóng chai sẵn.</span></li>
        </ul>
        <p>&nbsp;</p>
        <ol>
          <li style={{fontWeight: 400}}><span style={{fontWeight: 400}}>Ưu Đãi Đặc Biệt và/hoặc Thư Mời: theo quyết định chỉ riêng của Starbucks, bạn có thể nhận thêm (các) đề nghị và/hoặc thư mời đặc biệt để tham gia vào (các) sự kiện được tổ chức bởi hoặc cho Starbucks bằng email hoặc thư. </span><strong>Bạn phải đồng ý nhận các đề nghị khuyến mại và tiếp thị từ Starbucks và có thể được yêu cầu cung cấp địa chỉ email, điện thoại và địa chỉ hợp lệ để nhận các đề nghị và thư mời đặc biệt của bạn</strong><span style={{fontWeight: 400}}>.</span> <span style={{fontWeight: 400}}>Đề nghị và thư mời đặc biệt có thể được tùy chỉnh dựa trên thói quen và sở thích mua hàng. Đề nghị đặc biệt có thể bao gồm giảm giá định kỳ đối với món ăn, đồ uống và hàng hóa. Đề nghị đặc biệt có thể có những hạn chế nhất định bao gồm cả ngày hết hạn và thời gian nhận thưởng với thời hạn ngắn. Đề nghị đặc biệt là dành riêng cho cá nhân bạn và không thể được chia sẻ, sao chép hoặc chuyển giao. Bạn có thể được yêu cầu xuất trình Thẻ Starbucks đã đăng ký hoặc mã vạch tương ứng trên Ứng Dụng Di Động của bạn để nhận các đề nghị đặc biệt. Vui lòng xem kỹ từng đề nghị để biết thêm về chi tiết, ngày hết hạn, các hạn chế và giới hạn cụ thể khi đề nghị như vậy được tặng vào tài khoản của bạn.&nbsp;</span></li>
        </ol>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bạn chịu trách nhiệm cho việc cập nhật tài khoản Starbucks Rewards™ của bạn và đảm bảo tất cả các thông tin mà bạn cung cấp trong tài khoản của bạn là chính xác và cập nhật tại mọi thời điểm, bao gồm email và địa chỉ gửi thư tại </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a><span style={{fontWeight: 400}}>. Nếu bất cứ thông tin bạn cung cấp không chính xác hoặc không được cập nhật, bạn có thể không nhận được (các) đề nghị và/hoặc thư mời đặc biệt. Bạn có thể xem và theo dõi (các) đề nghị và/hoặc thư mời đặc biệt được cung cấp cho bạn tại </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a><span style={{fontWeight: 400}}> hoặc thông qua Ứng Dụng Di Động.</span></p>
        <p>&nbsp;</p>
        <p>
            <strong>Đặt Hàng & Thanh Toán trên Ứng Dụng Di Động</strong>
        </p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Chức năng Đặt Hàng & Thanh Toán trên Ứng Dụng Di Động này</span>
            <strong>(“MO&P”)</strong>
            <span style={{ fontWeight: 400 }}>
            cho phép bạn đặt hàng và thanh toán trước khi đến cửa hàng Starbucks đã chọn. Với tính năng này, bạn đã gửi yêu cầu đến nhân viên pha chế thực hiện đơn đặt hàng cho bạn và giao tại khu vực giao hàng của cửa hàng vào thời gian giao hàng bạn đã chọn mà không cần xếp hàng hay trả thêm phí dịch vụ cho tính năng này. Tính năng này chỉ được tích hợp vào Ứng Dụng Di Động và áp dụng cho (các) thành viên của Chương trình Starbucks Rewards™. Bạn được yêu cầu bật dịch vụ định vị trên thiết bị của mình và đảm bảo cập nhật mới nhất cho Ứng Dụng Di Động để khám phá chức năng mới này.
            </span>
        </p>
        <p>&nbsp;</p>
        <span style={{ fontWeight: 400 }}>
        Tính năng MO&P này hiện có trên Ứng Dụng Di Động để bạn sử dụng thông qua các bước đơn giản sau:
        </span>
        <p>&nbsp;</p>
        <ol>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Truy cập phiên bản mới nhất của Ứng Dụng Di Động và đăng nhập vào tài khoản của bạn.
                </strong>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Chọn thẻ “Đặt món” từ thanh menu:
                </strong>
                <span style={{ fontWeight: 400 }}>
                dịch vụ định vị trên thiết bị của bạn được yêu cầu bật lên để bắt đầu sử dụng tính năng này.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Chọn các món ăn và đồ uống để đặt hàng:
                </strong>
                <span style={{ fontWeight: 400 }}>
                Cũng giống như tại các cửa hàng của chúng tôi, món ăn và đồ uống có thể tùy chỉnh, bao gồm ở nhiều tùy chọn để thay đổi các lựa chọn về kích cỡ, số lượng ly cà phê espresso, sữa và các lựa chọn khác.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Chọn cửa hàng để nhận hàng:
                </strong>
                <span style={{ fontWeight: 400 }}>
                thời gian nhận hàng dự kiến có thể hiển thị trên thiết bị của bạn trước khi chọn vị trí cửa hàng Starbucks. Các món trong thực đơn cũng sẽ được cập nhật dựa trên tình trạng sẵn có sau khi cửa hàng Starbucks được chọn. Bạn nên xem lại để đảm bảo các lựa chọn / đơn đặt hàng của bạn có thể được phục vụ tại cửa hàng Starbucks được chọn trước khi nhấn “thanh toán”.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Xác nhận bằng cách nhấn vào "Thanh toán":
                </strong>
                <span style={{ fontWeight: 400 }}>
                thông tin chi tiết về đơn đặt hàng của bạn, thời gian nhận hàng dự kiến, cửa hàng nhận hàng và tổng số tiền thanh toán của bạn sẽ được hiển thị để bạn xem lại và xác nhận.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Tiến hành thanh toán:
                </strong>
                <span style={{ fontWeight: 400 }}>
                thanh toán được thực hiện bằng Thẻ Starbucks đã đăng ký mặc định của bạn.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Hoàn thành đơn đặt hàng của bạn:
                </strong>
                <span style={{ fontWeight: 400 }}>
                cửa sổ thông báo với Biên lai điện tử (eReceipt) cho đơn đặt hàng của bạn và bộ đếm ngược thời gian nhận hàng dự kiến sẽ được hiển thị. Bạn cũng có thể kiểm tra thông tin này và tại Lịch Sử Giao Dịch.
                </span>
            </li>
            <p>&nbsp;</p>
            <li style={{ fontWeight: 400 }}>
                <strong>
                Đến cửa hàng Starbucks đã chọn để nhận đồ ăn và thức uống của bạn:
                </strong>
                <span style={{ fontWeight: 400 }}>
                Các đơn đặt hàng ngay lập tức được gửi đến cửa hàng Starbucks đã chọn, nơi nhân viên pha chế sẽ bắt đầu chuẩn bị các đồ an và thức uống. Khi nhân viên pha chế đã hoàn thành đơn đặt hàng của bạn, bạn sẽ nhận được thông báo (push notification) được gửi qua Ứng Dụng Di Động để đến nhận hàng trong thời gian nhận hàng dự kiến và thưởng thức đồ ăn / đồ uống của bạn.
                </span>
            </li>
        </>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Trước tiên, Ứng Dụng Di Động sẽ mặc định đơn đặt hàng gần nhất của bạn và cửa hàng Starbucks sẵn có gần nhất trong vòng bán kính 50 km tính từ vị trí hiện tại của bạn, cũng như hiển thị tình trạng sẵn có của thực đơn hiện tại và thời gian nhận hàng dự kiến cho đơn đặt hàng của bạn tại cửa hàng đó. Bạn có thể thay đổi cửa hàng bằng cách chạm vào bản đồ để lựa chọn hoặc sử dụng nút "Nhận Tại" trong ứng dụng. Khi đơn đặt hàng của bạn đã được gửi, bạn không thể thay đổi cửa hàng nhận hàng. Bạn chỉ có thể đặt hàng sau khi cửa hàng Starbucks được chọn mở cửa và đến 30 phút trước khi cửa hàng Starbucks đó đóng cửa.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Hầu hết tất cả đồ ăn và thức uống Starbucks yêu thích của bạn đều được cung cấp thông qua tính năng MO&P ngoại trừ đồ uống có cồn, nước đóng chai/lon sẵn, hàng hóa lưu niệm, cà phê hạt. Thực đơn cho lựa chọn của bạn sẽ liệt kê tất cả các đồ ăn và thức uống có thể cung cấp với cùng một mức giá tại cửa hàng Starbucks được chọn. Với một vài thao tác trên thiết bị, bạn có thể tùy chỉnh đồ uống yêu thích của bạn và lựa chọn để được phục vụ đồ ăn được làm nóng, như thể bạn có thể yêu cầu tại cửa hàng.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Khi bạn đặt đơn hàng, bạn sẽ được thông báo thời gian nhận hàng dự kiến mà không có bất kỳ lựa chọn nào để bạn thay đổi hoặc yêu cầu cụ thể thời gian nhận hàng dự kiến này. Thời gian sẽ thay đổi tùy thuộc vào nhiều yếu tố khác nhau bao gồm ở tình trạng sẵn sàng của cửa hàng Starbucks, số lượng đồ ăn và thức uống được đặt và thời điểm trong ngày. Bạn có thể đến cửa hàng Starbucks được chọn trong khoảng thời gian nhận hàng dự kiến.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Việc thanh toán cho đơn đặt hàng của bạn qua tính năng MO&P phải được hoàn thành bằng Thẻ Starbucks đã đăng ký thông qua Ứng Dụng Di Động. Số tiền trả trước của bạn trên Thẻ Starbucks đã đăng ký đó sẽ được hệ thống của chúng tôi khấu trừ cho giao dịch đặt hàng này. Starbucks cũng có các tiêu chuẩn bảo mật riêng cho các giao dịch khấu trừ này để đảm bảo thông tin bảo mật và an toàn. Trong trường hợp phát sinh giao dịch không mong muốn, vui lòng liên hệ với Trung Tâm Dịch Vụ Khách Hàng của chúng tôi để chúng tôi có thể hỗ trợ kịp thời.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Sau khi đặt hàng qua tính năng MO&P, đơn đặt hàng sẽ được gửi ngay đến cửa hàng Starbucks được chọn và nhân viên pha chế của chúng tôi sẽ bắt đầu chuẩn bị đơn đặt hàng này. Bạn không thể thay đổi cửa hàng Starbucks được chọn, sửa đổi hoặc hủy đơn đặt hàng, trả lại đồ ăn / thức uống đã đặt, yêu cầu hoàn tiền trong bất kỳ trường hợp nào hoặc đặt bất kỳ đơn hàng nào khác tại cùng một thời điểm.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Vui lòng đảm bảo các thông báo được cho phép hiển thị trong cài đặt trong Ứng Dụng Di Động và thiết bị của bạn để nhận thông báo đẩy khi đơn đặt hàng của bạn đã sẵn sàng để nhận tại cửa hàng Starbucks được chọn trong thời gian nhận hàng dự kiến. Bạn thừa nhận rằng Starbucks không thể duy trì chất lượng của các đồ ăn / thức uống được đặt như bạn mong muốn trong trường hợp bạn đến nhận hàng muộn hơn thời gian nhận hàng dự kiến, mặc dù đã nhận được thông báo đẩy và đồng ý giữ cho Starbucks vô hại khỏi bất kỳ trách nhiệm pháp lý nào trong trường hợp này. Tuy nhiên, trong khả năng có thể, chúng tôi luôn cố gắng mang đến những sản phẩm chất lượng nhất cho bạn.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Bạn cũng có thể tích lũy Điểm Ngôi Sao cho việc mua hàng được thực hiện thông qua tính năng MO&P này.
            </span>
        </p>
        <p>&nbsp;</p>
        <p>
            <span style={{ fontWeight: 400 }}>
            Bạn có thể liên hệ với Trung tâm Chăm sóc Khách hàng Starbucks Rewards ™ của chúng tôi theo thông tin bên dưới nếu bạn gặp bất kỳ vấn đề nào trong quá trình sử dụng tính năng MO&P này.
        </p>
        <p>&nbsp;</p>
        <p><strong>Quy Định Khác</strong></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Bạn không phải trả phí thành viên cho việc tham gia Chương trình Starbucks Rewards™, nhưng khi đăng ký tài khoản Starbucks Rewards™, bạn cần nạp tối thiếu 100.000 đồng để kích hoạt Thẻ Starbucks của bạn. Điểm Ngôi Sao tích lũy trong chương trình không có giá trị quy đổi thành tiền mặt.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Starbucks có thể giới thiệu các chương trình khuyến mại liên quan đến Chương trình Starbucks Rewards™ theo đó các Điều Khoản Sử Dụng này có thể được thay đổi để áp dụng cho các chương trình đó.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Chương trình Starbucks Rewards™ sẽ được triển khai như trong thời hạn đã thông báo cho cơ quan có thẩm quyền và thông báo tại các cửa hàng Starbucks tại Việt Nam. Theo đó, tài khoản Starbucks Rewards™ và tất cả Thẻ Starbucks đã đăng ký của bạn sẽ hết hạn vào ngày kết thúc Chương trình Starbucks Rewards™, do đó tất cả Điểm Ngôi Sao được tích lũy trong tài khoản của bạn sẽ không còn giá trị vào ngày kết thúc Chương trình đó mà Starbucks không chịu bất cứ trách nhiệm nào đối với bạn. Trong trường hợp này, bạn sẽ được thông báo để nhận / quy đổi số dư trong tất cả Thẻ Starbucks đã đăng ký của bạn trong khoảng thời hạn cụ thể sẽ được thông báo cụ thể đến bạn.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Starbucks có toàn quyền quyết định trong việc tiếp tục thực hiện Chương trình Starbucks Rewards™ cho các giai đoạn tiếp theo tùy thuộc vào thông báo cho cơ quan có thẩm quyền, và trong trường hợp này, Starbucks hoàn toàn có quyền, nhưng không có nghĩa vụ, trong việc gia hạn thời hạn tài khoản Starbucks Rewards và Thẻ Starbucks đã đăng ký của bạn, tùy thuộc vào các điều khoản về thời hạn của Thẻ Starbucks được quy định tại Mục có đề mục “Thẻ Starbucks” và nội dung trong đó.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Trừ trường hợp pháp luật có quy định khác, Starbucks sẽ không chấp nhận hoặc thực hiện bất cứ sự đổi hoặc hoàn trả nào đối với hàng hoá, dịch vụ đã mua tại các cửa hàng Starbucks. Trong trường hợp phải hoàn trả, theo quyết định chỉ riêng của Starbucks, Starbucks bảo lưu quyền trừ các quyền lợi và số Điểm Ngôi Sao đã được tích lũy, kể cả Điểm Ngôi Sao Khuyến Mại, nếu có, tương ứng với giá trị mua của hàng hóa dịch vụ được hoàn trả.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Nếu Thẻ Starbucks của bạn bị mất, bị đánh cắp hoặc bị phá hủy, bạn có thể sẽ mất số dư tiền trong Thẻ Starbucks của bạn. Tuy nhiên, trong trường hợp là thành viên của Chương Trình Starbucks Rewards™, bạn có thể bảo toàn số dư Điểm Ngôi Sao trên tài khoản Starbucks Rewards</span><span style={{fontWeight: 400}}>TM</span><span style={{fontWeight: 400}}> của bạn, nếu bạn thông báo về việc Thẻ bị mất, bị đánh cắp, phá hủy thông qua website </span><a href="https://card.starbucks.vn"><span style={{fontWeight: 400}}>https://card.starbucks.vn</span></a><span style={{fontWeight: 400}}> hoặc Ứng Dụng Di Động hoặc gọi tới Trung Tâm Chăm Sóc Khách Hàng Starbucks Rewards™ tại (028) 7306 7676, và xác nhận chỉ dẫn của bạn. Trong trường hợp bạn chỉ có một Thẻ Starbuck đã đăng ký, bạn có thể gửi cho chúng tôi yêu cầu cấp lại Thẻ Starbucks thay thế , theo đó, tất cả số dư của Thẻ Starbuck Cards bị mất/bị đánh cắp/bị hủy hoại này có thể được chuyển qua Thẻ thay thế và bạn có thể tiếp tục sử dụng Thẻ thay thế này để nhận các ưu đãi chưa sử dụng trong thời hạn có hiệu lực của ưu đãi đó, ngược lại trong trường hợp bạn có nhiều hơn một Thẻ Starbucks đã đăng ký, số dư của Thẻ Starbucks Cards bị mất/bị đánh cắp/bị hủy hoại này sẽ được chuyển đến một trong các Thẻ Starbucks đã đăng ký khác của bạn.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Điểm Ngôi Sao, các Ưu Đãi, (các) Thẻ Starbucks đã đăng ký của bạn, và tài khoản của bạn trong Chương trình Starbucks Rewards™ là dành riêng cho cá nhân bạn và không thể bán, chuyển giao hoặc chuyển nhượng, hoặc chia sẻ với gia đình, bạn bè hoặc những người khác, hoặc sử dụng bởi bạn cho bất cứ mục đích thương mại nào. Bạn được yêu cầu sử dụng địa chỉ email của bạn để đăng ký tài khoản Starbucks Rewards™ dành riêng cho bạn và mỗi địa chỉ email của bạn có thể được sử dụng để đăng ký duy nhất (1) một tài khoản Starbucks Rewards™.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Starbucks bảo lưu quyền “hủy đăng ký” tài khoản Starbucks Rewards™ đối với bất cứ Thẻ Starbucks mà hết hạn hoặc không hoạt động mà không cần phải thông báo đến bạn. Trong trường hợp Thẻ hoặc tài khoản Starbucks Rewards™ của bạn bị hủy đăng ký hoặc bị xem xét là không hoạt động, thì tất cả các Điểm Ngôi Sao được tích lũy trong tài khoản của bạn không có giá trị.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Starbucks bảo lưu quyền đình chỉ bất cứ Thẻ Starbucks đã đăng ký và/hoặc chấm dứt tài khoản Starbucks Rewards</span><span style={{fontWeight: 400}}>TM</span><span style={{fontWeight: 400}}> của bạn và/hoặc sự tham gia của bạn vào Chương trình Starbucks Rewards™ theo quyết định chỉ riêng của Starbucks mà không cần thông báo đến bạn nếu Starbucks xác định rằng bạn đã vi phạm bất kỳ điều khoản nào của Điều khoản Sử dụng này và các điều khoản được kết hợp bằng việc tham chiếu, hoặc một địa chỉ email của bạn được sử dụng để đăng ký cho nhiều hơn một (1) tài khoản Starbucks Rewards™, hoặc việc sử dụng tài khoản Starbucks Rewards™ của bạn là trái phép, lừa đảo, gian lận hoặc trái pháp luật. Theo quyết định chỉ riêng của Starbucks, Starbucks có thể đình chỉ, hủy bỏ hoặc kết hợp các tài khoản thể hiện như là bản sao của nhau. Trong trường hợp sự tham gia của bạn vào Chương trình Starbucks Rewards™ bị chấm dứt, thì tất cả các Điểm Ngôi Sao được tích lũy trong tài khoản của bạn không có giá trị, và tất cả số dư trong Thẻ Starbucks đã đăng ký của bạn sẽ trở thành doanh thu của Starbucks mà Starbucks không phải chịu bất kỳ trách nhiệm nào đối với chủ Thẻ Starbucks.&nbsp;</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Tất cả các khiếu nại hoặc tranh chấp phát sinh từ hoặc liên quan đến các Điều Khoản Sử Dụng hoặc Chương trình Starbucks Rewards™ này™ sẽ được giải quyết theo pháp luật được áp dụng tại Việt Nam.</span></p>
        <p>&nbsp;</p>
        <p><span style={{fontWeight: 400}}>Nếu bạn có bất cứ thắc mắc liên quan đến Chương trình Starbucks Rewards™, xin vui lòng liên hệ tới Công ty TNHH Thực phẩm &amp; Nước giải khát Ý Tưởng Việt, bằng cách gửi thư tới 76 Lê Lai, Phường Bến Thành, Quận 1, Thành phố Hồ Chí Minh hoặc thông qua Trung tâm Chăm sóc Khách hàng Starbucks Rewards™ số (028) 7306 7676.&nbsp;</span></p>
      </div>`,
	],
}

export default LangTermNConditionPopup



// WEBPACK FOOTER //
// ./src/resources/pages/LangTermNConditionPopup.js